import * as React from "react";
import styled, { css } from "styled-components";

import Icon from "./Icon";
import { theme } from "./theme";

export interface ImageProps {
  src?: string | null;
  alt?: string;
  className?: string;
  tips: {
    error: string;
  };
  isCover?: boolean;
  defaultIcon?: React.ReactChild;
}

interface ImageStates {
  failed: boolean;
  loaded: boolean;
}

const cameraIcon = <Icon type="camera" size="60px" color="white" />;

const Image: React.FC<ImageProps> = React.memo((props) => {
  const [failed, setFailed] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);
  const {
    src,
    alt,
    isCover,
    defaultIcon,
    className,
    tips: { error },
  } = props;

  return (
    <>
      {!loaded && (
        <TipImage className={`image-background ${className}`}>
          {defaultIcon || (src && failed ? error : cameraIcon)}
        </TipImage>
      )}
      {src && !failed && (
        <BaseImage
          hide={!loaded}
          className={className}
          onLoad={() => setLoaded(true)}
          src={src}
          alt={alt}
          onError={() => setFailed(true)}
          isCover={isCover}
        />
      )}
    </>
  );
});

export { Image, TipImage, BaseImage };

const TipImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: white;
  background-color: ${theme.imageBgColor};
  overflow: hidden;
`;

const BaseImage = styled.img<{ hide?: boolean; isCover?: boolean }>`
  width: 100%;
  height: 100%;
  ${({ hide }) =>
    hide &&
    css`
      display: none;
    `}
  ${({ isCover }) =>
    isCover
      ? css`
          object-fit: cover;
          object-position: center;
        `
      : css`
          object-fit: contain;
          object-position: center;
        `};
`;
